import type { Deployment } from "../../../schemas";
import { formatShortDistance } from "./date-utils";

/**
 * Formats a deployment as a human-readable version string
 */
export function formatDeploymentVersion(
  deployment: Deployment | null | undefined,
): string {
  if (!deployment) {
    return "-";
  }

  // Show status-based labels for better UX
  switch (deployment.status) {
    case "complete":
      return "Live";
    case "executing":
      return "Deploying...";
    case "pending":
      return "Queued";
    case "error":
      return "Failed";
    case "cancelled":
      return "Cancelled";
    default:
      // Fallback to relative time for any other status
      return formatShortDistance(new Date(deployment.createdAt));
  }
}

/**
 * Gets version status color based on deployment status
 */
export function getVersionStatusColor(
  deployment: Deployment | null | undefined,
): string {
  if (!deployment) {
    return "text-muted-foreground";
  }

  switch (deployment.status) {
    case "complete":
      return "text-success";
    case "executing":
    case "pending":
      return "text-warning";
    case "error":
    case "cancelled":
      return "text-destructive";
    default:
      return "text-muted-foreground";
  }
}
